import { render, staticRenderFns } from "./Difficulty.vue?vue&type=template&id=d42b9c14&"
import script from "./Difficulty.vue?vue&type=script&lang=js&"
export * from "./Difficulty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports